import { Pencil } from "lucide-react";
import { FIND_RIDE_COLORS } from "../constants/findRide.constants";
import { tFindRide } from "../locales/FindRideTranslations";
import type {
  FindRideResultItem,
  FindRideSearchCriteria,
} from "../types/findRide.types";
import { FindRideResultCard } from "./FindRideResultCard";
import { FindRideRouteSummary } from "./FindRideRouteSummary";

export type FindRideResultsListProps = {
  criteria: FindRideSearchCriteria;
  rides: FindRideResultItem[];
  totalRides: number;
  onEditDetails: () => void;
};

/**
 * Results-only view after View & Book — Edit Details returns to the search form.
 */
export function FindRideResultsList({
  criteria,
  rides,
  totalRides,
  onEditDetails,
}: FindRideResultsListProps) {
  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button
          type="button"
          onClick={onEditDetails}
          className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-800 shadow-sm transition-colors hover:bg-gray-50"
        >
          <Pencil
            className="h-4 w-4"
            style={{ color: FIND_RIDE_COLORS.pageGreen }}
          />
          {tFindRide("editDetails")}
        </button>
        <p className="text-sm font-semibold text-gray-700">
          {tFindRide("ridesAvailableTitle", {
            count: totalRides || rides.length,
          })}
        </p>
      </div>

      <FindRideRouteSummary
        pickup={criteria.pickup}
        drop={criteria.drop}
        date={criteria.date}
        seats={criteria.seats}
      />

      {rides.length === 0 ? (
        <p className="rounded-2xl bg-white px-4 py-8 text-center text-sm text-gray-600 shadow-sm">
          {tFindRide("noRideCards")}
        </p>
      ) : (
        <ul className="space-y-3">
          {rides.map((ride) => (
            <li key={ride.key}>
              <FindRideResultCard ride={ride} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
